import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { TranslocoModule } from '@ngneat/transloco';

import { ComponentsModule } from '@core/components/components.module';
import { SharedModule } from '@core/shared.module';

import { InventoryEffects } from '@inventory/state';

import { InventoryRoutingModule } from './inventory-routing.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ComponentsModule,
    TranslocoModule,
    InventoryRoutingModule,
    EffectsModule.forFeature([InventoryEffects]),
  ],
})
export class InventoryModule {}
